import { ReactNode } from 'react';

import { useTabsContext } from './Tabs';

type Props = {
  children: ReactNode;
  value: number;
  contextId?: string;
};

const TabsContent = ({ children, value, contextId = 'default' }: Props) => {
  const { activeTab } = useTabsContext(contextId);

  if (activeTab !== value) return null;

  return <div>{children}</div>;
};

export default TabsContent;
